import * as React from 'react'

import Main from '../components/Main'

export default () => <Main isAmp={false} />
